<template>
  <box :title="title">
    <p>
      {{ company.name }}
    </p>
    <p>
      {{ companyDetail.street }}
    </p>
    <p>
      {{ companyAddress }}
    </p>
    <p>
      {{ companyDetail.country }}
    </p>
    <div style="text-transform: none;">
      <div class="half">{{ translate('contact')}}: {{ companyContact.name }}</div>
      <div class="half">{{ translate('tel') }}: {{ companyContact.phone }}</div>
    </div>
    <p>
      <span>{{ translate('vat') }} {{ translate('number-symbol') }}:</span>
      <span>{{ vatNumber === undefined ? companyDetail.vatNumber : vatNumber }}</span>
    </p>
  </box>
</template>

<script>
import Box from './box'

export default {
  name: 'company-box',
  components: {
    'box': Box
  },
  props: {
    translate: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    companyDetail: {
      type: Object,
      required: true
    },
    companyContact: {
      type: Object,
      required: true
    },
    vatNumber: {
      required: false,
      type: Number
    }
  },
  computed: {
    companyAddress () {
      return [this.companyDetail.city, this.companyDetail.zipCode, this.companyDetail.state].filter(Boolean).join(', ')
    }
  }
}
</script>
